export const apiEndpoint = "https://risponline.co.za/Controller/controller.php";//"https://risponline.co.za";
export const generalApiEndpoint = "https://risponline.co.za";//"https://risponline.co.za";